export enum EventTypes {
    GENERAL = 'General',
    BEHAVIOR = 'Behavior',
}

export interface IEvent {
    uid?: string;
    type: EventTypes;
    date: string;
    limit: number;
    patientTotal?: number;
}